<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch03-01">
<p class="centerImage"><img alt="images" src="images/img22_1.jpg"/></p>
<p class="caption"><em class="italic">2 Border Colours at laying up ceremony in Carlisle Cathedral 5 August 1914.</em> <span class="smallcaps">Ashley Kendall</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 013_ch0301.vue?6c336ec2